"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteTableField = exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_window_infinite_loader_1 = __importDefault(require("react-window-infinite-loader"));
const lodash_1 = require("lodash");
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const table_field_1 = require("../table-field/table-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const remote_table_field_context_1 = require("./remote-table-field-context");
exports.useStyles = (0, makeStyles_1.default)((theme) => ({
    noMatch: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '15px 0',
        // zIndex: 99,
    },
}));
function ListWrapper({ children }) {
    const classes = (0, exports.useStyles)();
    const { source } = (0, react_1.useContext)(remote_table_field_context_1.RemoteTableFieldContext);
    const totalCount = (source === null || source === void 0 ? void 0 : source.hasNextPage())
        ? (source === null || source === void 0 ? void 0 : source.items.length) + 1
        : source === null || source === void 0 ? void 0 : source.items.length;
    const isItemLoaded = (0, react_1.useCallback)((index) => {
        return source.isDataValid() && index < source.items.length;
    }, [source]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (source === null || source === void 0 ? void 0 : source.items.length) === 0 && source.loading === false && (react_1.default.createElement("div", { className: classes.noMatch },
            react_1.default.createElement(Typography_1.default, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_EMPTY_SOURCE", defaultMessage: "Nejsou dostupn\u00E9 \u017E\u00E1dn\u00E9 z\u00E1znamy." })))),
        source.loading === true && (react_1.default.createElement("div", { className: classes.noMatch },
            react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "primary" }))),
        react_1.default.createElement(react_window_infinite_loader_1.default, { isItemLoaded: isItemLoaded, itemCount: totalCount, loadMoreItems: source.loadMore, threshold: 1 }, (props) => (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.toArray(children)
            .filter(react_1.default.isValidElement)
            .map((child) => react_1.default.cloneElement(child, props)))))));
}
exports.RemoteTableField = (0, react_1.forwardRef)(function RemoteTableField({ source, ...options }, ref) {
    var _a, _b, _c;
    const handleSortChange = (0, event_callback_hook_1.useEventCallback)((sort) => {
        source.setParams({
            ...source.getParams(),
            sort,
        });
        source.reset();
        source.loadMore();
    });
    return (react_1.default.createElement(remote_table_field_context_1.RemoteTableFieldContext.Provider, { value: { source } },
        react_1.default.createElement(table_field_1.TableField, { ...options, ref: ref, ListWrapperComponent: ListWrapper, onChange: lodash_1.noop, onSortChange: handleSortChange, defaultSort: (_c = (_b = (_a = source.getParams()) === null || _a === void 0 ? void 0 : _a.sort) !== null && _b !== void 0 ? _b : options.defaultSort) !== null && _c !== void 0 ? _c : [], value: source.items })));
});
//# sourceMappingURL=remote-table-field.js.map